import { gql } from "@apollo/client";

export type GetVenueReservationBoundsQueryInput = {
  venuePortalUserId: string;
  venueId?: string;
  productId?: string;
};

export type GetVenueReservationBoundsQueryResponse = {
  venuePortalUser: {
    id: string;
    reservationBounds: {
      earliestDate: Date | null;
      latestDate: Date | null;
    };
  } | null;
};

export const GET_VENUE_RESERVATION_BOUNDS_QUERY = gql`
  query GetVenuePortalUserVenueReservationBounds(
    $venuePortalUserId: ID!
    $venueId: ID
    $productId: ID
  ) {
    venuePortalUser(id: $venuePortalUserId) {
      id
      reservationBounds(venueId: $venueId, productId: $productId) {
        earliestDate
        latestDate
      }
    }
  }
`;
